var _style, _path, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBidupIconSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 400.1",
    style: {
      enableBackground: "new 0 0 450 400.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00C213;}\n\t.st1{fill:#00870D;}\n\t.st2{fill:#DEECF1;}\n\t.st3{fill:#A8D3D8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450,50v300.1c0,27.6-22.4,50-50,50H50c-27.6,0-50-22.4-50-50V50C0,22.4,22.4,0,50,0h350 C427.6,0,450,22.4,450,50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M450,50.1v300c0,27.6-22.4,50-50,50H225V0h174.9C427.6,0,450,22.4,450,50.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240,195.1v120c0,8.4-6.6,15-15,15s-15-6.6-15-15v-120c0-8.4,6.6-15,15-15S240,186.7,240,195.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180,225.1c0-24.8-20.2-45-45-45h-30c-8.3,0-15,6.7-15,15v120c0,8.3,6.7,15,15,15h30c24.8,0,45-20.2,45-45 c0-11.6-4.5-22-11.7-30C175.5,247.1,180,236.7,180,225.1z M120,210.1h15c8.3,0,15,6.7,15,15s-6.7,15-15,15h-15V210.1z M135,300.1 h-15v-30h15c8.3,0,15,6.7,15,15S143.3,300.1,135,300.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M315,330.1h-30c-8.3,0-15-6.7-15-15v-120c0-8.3,6.7-15,15-15h30c24.8,0,45,20.2,45,45v60 C360,309.9,339.8,330.1,315,330.1z M300,300.1h15c8.3,0,15-6.7,15-15v-60c0-8.3-6.7-15-15-15h-15V300.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M225,330.1v-150c8.4,0,15,6.6,15,15v120C240,323.5,233.4,330.1,225,330.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.4,130.5c5.1,5.1,13.4,5.1,18.5,0c5.1-5.1,5.1-13.4,0-18.5l-47.7-47.7c-5.1-5.1-13.4-5.1-18.5,0L168,112 c-5.1,5.1-5.1,13.4,0,18.5c5.1,5.1,13.4,5.1,18.5,0L225,92.1L263.4,130.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidupIconSimple);
export default __webpack_public_path__ + "static/media/bidup_icon-simple.df1b581eab5c0af7cc0fe777f241437b.svg";
export { ForwardRef as ReactComponent };